export const InternalRoles = ["Manager", "Trainee", "Marketing", "Comercial", "Internal", "Consultant", "Administrator"];

export const ExternalRoles = ["HumanResources", "TechnicianLimited", "Technician", "Dossie", "Financial", "Master"];